import { atom } from 'recoil';
import { IUser } from '../interfaces/Models';

export const userAtom = atom({
  key: 'user',
  default: null as IUser | null,
});
